import React from 'react';
import { Input, Button, PaperClip, Select } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {
	
	render() {
		const i = this.props.item;

		return (
			<div id="modal-view-payment">
				{
					i && (
						<React.Fragment>
							<p><strong>Fecha de Vencimiento:</strong> { moment(i?.next_payment).isValid() ? moment(i?.next_payment).format('DD-MM-YYYY') : '' }</p>
							<p><strong>Usuario:</strong> { i?.plan_user?.user?.name }</p>
							<p><strong>Plan de Suscripción:</strong> { i?.plan_user?.plan?.name }</p>
							<p><strong>Monto Pagado:</strong> <span className="price">{ Globals.formatMiles(i?.amount) }</span></p>
							<p><strong>Medio de Pago:</strong> { i?.payment_method?.name }</p>
							{ i.email && <p><strong>Correo emisor:</strong> { i.email }</p> }
							{ i.phone && <p><strong>Teléfono emisor:</strong> { i.phone }</p> }
							{ i.date && <p><strong>Fecha de pago:</strong> { moment(i?.date).isValid() ? moment(i?.date).format('DD-MM-YYYY') : '' }</p> }
							{ i.bank_account && <p><strong>Cuenta destino:</strong> { i.bank_account?.bank?.name || i.bank_account?.bank_name } { i.bank_account?.number }</p> }
							{ (i?.bank?.name || i.bank_name) && <p><strong>Banco emisor:</strong> { i?.bank?.name || i.bank_name }</p> }
							<p><strong>Nº Referencia:</strong> { i?.reference || '-' }</p>
							{ i.photo && <p><strong>Foto del pago:</strong> <a href={ Constants.BASE_STORAGE + i.photo }>Ver</a></p> }
							<p><strong>Estatus del pago:</strong> { i?.status_text }</p>
							<p><strong>Estatus suscripción:</strong> { i?.plan_user?.user?.last_payment?.id == i?.id && moment(i?.next_payment).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD') ? 'Activo' : 'Inactivo' }</p>
							{ i.comments && <p><strong>Comentarios:</strong> { i.comments }</p> }
						</React.Fragment>
					)
				}
				<div className="row row-buttons">
					<div className="col-md-12 text-center">
						<Button type="button" onClick={ () => this.props.onClose() }>
							Cerrar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalView;